import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d15fa292"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog-contents"
}
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = { class: "dialog-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shuoming" })
], -1))
const _hoisted_5 = { class: "info-tips" }
const _hoisted_6 = { class: "dialog-edit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.tips), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "edit edit-left",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
            }, _toDisplayString(_ctx.confirmText), 1),
            _createElementVNode("div", {
              class: "edit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
            }, _toDisplayString(_ctx.cancelText), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}